import { ActionsColumn } from "./ActionsColumn"
import { Library } from "./Library"

export const cell = {
  display: "flex",
  alignItems: "center",
  justifyContent: "left",
  maxHeight: "fit-content !important",
  overflow: "hidden",
  padding: "5px 16px",
  whiteSpace: "nowrap",
  wordBreak: "break-word",
  borderBottom: "none",

  "& div": {
    alignItems: "center",
  },

  ...ActionsColumn.cell,
  ...Library.cell,

  // TODO: Place at the component level (not a theme)
  // TODO: Remove all other related "ellipsis" styles in the table and cells components (where Tooltip is used)
  "& .Tooltip-childrenContainer": {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  }
}
